import { Component } from '@angular/core';
import { NeverumeComponent } from "./../neverume.component";
import { ArrayAssociative } from "./../core/array.core.data";
import { MatDialogRef } from '@angular/material/dialog';
import { WebsocketService } from "./../services/websocket.service";
import { ModalService } from './../services/modal.service';
import { EventRunner } from './../core/app.core.events';
@Component({
  selector: 'postnick',
  templateUrl: './postnick.component.html',
  styleUrl: './postnick.component.scss',
  providers: [ ],
  standalone: !true
})
export class PostnickComponent {
	//dialogRef: MatDialogRef<PostnickComponent>;
	neverume: any;
	nick: any;
	
constructor(/*neverume: NeverumeComponent, /* */ private websoketService: WebsocketService,	 public dialogRef: MatDialogRef<any>) {
		//this.dialogRef = dialogRef;
	//this.neverume = neverume;
	}
	onSubmit() {
		let message: ArrayAssociative = {
				event: 'sendnick',
				route: '/profile/nick',
				nick: this.nick
			}
		this.websoketService.sendws(message);
		//this.neverume.sendMsg(message);
	}

	  close(): void {
	    this.dialogRef.close();
	  }

}
